(() => {
  const STORAGE_KEY = 'wc:wishlist';

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wc:wishlist:change', { detail: { items } }));
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[character]);

  const getButtonProduct = (button) => ({
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle || '',
    extraName: button.dataset.productExtraName || '',
    url: button.dataset.productUrl || '#',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || '',
  });

  const getPresetProducts = () => {
    const source = document.querySelector('[data-wc-wishlist-preset]');
    if (!source) return [];

    try {
      const parsed = JSON.parse(source.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const addPresetProducts = () => {
    const presetProducts = getPresetProducts();
    if (!presetProducts.length) return;

    const existingItems = readWishlist();
    const presetHandles = new Set(presetProducts.map((item) => item.handle));
    const mergedItems = [
      ...presetProducts,
      ...existingItems.filter((item) => !presetHandles.has(item.handle)),
    ];

    writeWishlist(mergedItems);
  };

  const updateButtons = () => {
    const items = readWishlist();
    const handles = new Set(items.map((item) => item.handle));
    const presetProducts = getPresetProducts();
    const presetLabel = document.querySelector('.wc-wishlist-preset-button')?.textContent?.trim() || 'Piazza verlanglijst';

    document.querySelectorAll('[data-wc-wishlist-button]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute(
        'aria-label',
        `${active ? 'Verwijder' : 'Voeg'} ${button.dataset.productTitle || 'product'} ${active ? 'uit' : 'toe aan'} verlanglijst`
      );
    });

    document.querySelectorAll('[data-wc-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });

    document.querySelectorAll('[data-wc-wishlist-preset-add]').forEach((button) => {
      button.hidden = presetProducts.length === 0;
      button.textContent = presetLabel;
    });
  };

  const renderWishlistPage = () => {
    const page = document.querySelector('[data-wc-wishlist-page]');
    if (!page) return;

    const grid = page.querySelector('[data-wc-wishlist-grid]');
    const empty = page.querySelector('[data-wc-wishlist-empty]');
    const clear = page.querySelector('[data-wc-wishlist-clear]');
    const items = readWishlist();

    if (!grid || !empty) return;

    empty.hidden = items.length > 0;
    if (clear) clear.hidden = items.length === 0;

    grid.innerHTML = items.map((item) => `
      <article class="wc-wishlist-card lpg-product-card" data-wc-wishlist-card="${escapeHtml(item.handle)}">
        <button class="wc-wishlist-card__remove" type="button" aria-label="Verwijder ${escapeHtml(item.title)} uit verlanglijst" data-wc-wishlist-remove="${escapeHtml(item.handle)}">
          <span class="icon-heart-piazza is-active" aria-hidden="true"></span>
        </button>
        <a class="wc-wishlist-card__media" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">
          ${item.image ? `<img class="wc-wishlist-card__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <a class="wc-wishlist-card__caption" href="${escapeHtml(item.url)}">
          <span class="wc-wishlist-card__text">
            <span class="wc-wishlist-card__title">${escapeHtml(item.title)}</span>
            ${item.extraName ? `<span class="wc-wishlist-card__extra-name">${escapeHtml(item.extraName)}</span>` : ''}
          </span>
          <span class="wc-wishlist-card__price">${escapeHtml(item.price)}</span>
        </a>
      </article>
    `).join('');
  };

  const renderWishlistDrawer = () => {
    const drawer = document.querySelector('[data-wc-wishlist-drawer]');
    if (!drawer) return;

    const list = drawer.querySelector('[data-wc-wishlist-drawer-list]');
    const empty = drawer.querySelector('[data-wc-wishlist-drawer-empty]');
    const count = drawer.querySelector('[data-wc-wishlist-drawer-count]');
    const fullLink = drawer.querySelector('[data-wc-wishlist-drawer-full-link]');
    const items = readWishlist();

    if (count) count.textContent = String(items.length);
    if (empty) empty.hidden = items.length > 0;
    if (fullLink) fullLink.hidden = items.length <= 3;
    if (!list) return;

    list.innerHTML = items.map((item) => `
      <li class="wc-wishlist-drawer__item">
        <a class="wc-wishlist-drawer__media" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">
          ${item.image ? `<img class="wc-wishlist-drawer__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="wc-wishlist-drawer__meta">
          <a class="wc-wishlist-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          ${item.extraName ? `<span class="wc-wishlist-drawer__item-extra-name">${escapeHtml(item.extraName)}</span>` : ''}
          <span class="wc-wishlist-drawer__price">${escapeHtml(item.price)}</span>
        </div>
        <button class="wc-wishlist-drawer__remove" type="button" aria-label="Verwijder ${escapeHtml(item.title)} uit verlanglijst" data-wc-wishlist-remove="${escapeHtml(item.handle)}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M4.75 4.75 15.25 15.25M15.25 4.75 4.75 15.25" stroke="currentColor" stroke-linecap="round" stroke-width="1.15"></path>
          </svg>
        </button>
      </li>
    `).join('');
  };

  const openWishlistDrawer = () => {
    const drawer = document.querySelector('[data-wc-wishlist-drawer]');
    if (!drawer) return;

    renderWishlistDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wc-wishlist-drawer-open');
  };

  const closeWishlistDrawer = () => {
    const drawer = document.querySelector('[data-wc-wishlist-drawer]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wc-wishlist-drawer-open');
  };

  const removeItem = (handle) => {
    writeWishlist(readWishlist().filter((item) => item.handle !== handle));
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-wc-wishlist-open]');
    if (openButton) {
      openWishlistDrawer();
      return;
    }

    const closeButton = event.target.closest('[data-wc-wishlist-close]');
    if (closeButton) {
      closeWishlistDrawer();
      return;
    }

    const presetButton = event.target.closest('[data-wc-wishlist-preset-add]');
    if (presetButton) {
      event.preventDefault();
      addPresetProducts();
      return;
    }

    const wishlistButton = event.target.closest('[data-wc-wishlist-button]');
    if (wishlistButton) {
      event.preventDefault();
      const product = getButtonProduct(wishlistButton);
      if (!product.handle) return;

      const items = readWishlist();
      const exists = items.some((item) => item.handle === product.handle);
      writeWishlist(exists ? items.filter((item) => item.handle !== product.handle) : [product, ...items]);
      if (!exists) openWishlistDrawer();
      return;
    }

    const removeButton = event.target.closest('[data-wc-wishlist-remove]');
    if (removeButton) {
      removeItem(removeButton.dataset.wcWishlistRemove);
      return;
    }

    const clearButton = event.target.closest('[data-wc-wishlist-clear]');
    if (clearButton) {
      writeWishlist([]);
    }
  });

  window.addEventListener('wc:wishlist:change', () => {
    updateButtons();
    renderWishlistPage();
    renderWishlistDrawer();
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    updateButtons();
    renderWishlistPage();
    renderWishlistDrawer();
  });

  window.addEventListener('wc:wishlist:refresh', () => {
    updateButtons();
    renderWishlistPage();
    renderWishlistDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeWishlistDrawer();
  });

  const init = () => {
    updateButtons();
    renderWishlistPage();
    renderWishlistDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
